import CertificateSelect from 'components/inputs/certificate-select/CertificateSelect';
import { IFormInputSpecCertificate } from 'pages/revisions-module/template-editor/editors/form/types';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { RevisionFieldProps } from 'components/forms/revision/fill-out/types';
import { useApi } from 'api/api-context';
import { TextInput } from '@mantine/core';
import { useMemo } from 'react';

/**
 * Certificate select input for the revision form.
 */
export default function RevisionFieldCertificate({ spec, name }: RevisionFieldProps<IFormInputSpecCertificate>) {
  const { userId } = useApi();
  const { form, revision } = useFillOutRevisionDataProvider();

  const isDelegatedToMe = useMemo(
    () => revision.delegatedTo?.some((user) => user.userId === userId),
    [revision, userId]
  );

  if (isDelegatedToMe) {
    const { certificateNumber = '', technicianName = '' } = form.getInputProps(name)?.value ?? {};
    const value = `${certificateNumber} (${technicianName})`;

    return <TextInput size="lg" label={spec.label} readOnly value={value} />;
  }

  return (
    <CertificateSelect
      required={spec.required}
      readOnly={spec.readOnly}
      size="lg"
      label={spec.label}
      searchable
      autoSelectSingleResult
      placeholder={
        revision.kind === 'revision' ? 'Vyberte osvedčenie revízneho technika' : 'Vyberte osvedčenie vypracovateľa'
      }
      loadingPlaceholder="Načítavanie ..."
      deviceTypeId={revision.deviceType.deviceTypeId}
      name={name}
      clearable={!spec.required}
      {...form.getInputProps(name)}
    />
  );
}
